export const getAllProducts = (state) => state.products;